const openEmailClient = (email) => {
  window.parent.location = `mailto:${email}`;
};

const copyToClipboard = (txt) => {
  navigator.clipboard.writeText(txt);
};

export { copyToClipboard, openEmailClient };
